import type { BibleBookId, BibleManifest } from "@packages/sdk";

type Props = {
  chapter: number;
  verse: number;
  preferredVariant?: "numeric" | "string";
} & (
  | { bookNumericId: number; book?: never; manifest?: BibleManifest }
  | { bookNumericId?: never; book: BibleBookId; manifest: BibleManifest }
);

export const getBibleVerseId = ({
  chapter,
  verse,
  bookNumericId,
  book,
  manifest,
  preferredVariant = "numeric",
}: Props): string | null => {
  if (!bookNumericId && preferredVariant === "numeric") {
    bookNumericId = manifest.books.find((bk) => bk.id === book)?.numeric_id;
  }

  if (!bookNumericId && !book) return null;

  return `v${bookNumericId?.toString()?.padStart(2, "0") ?? book}${chapter.toString().padStart(3, "0")}${verse.toString().padStart(3, "0")}`;
};
